(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zf-announcement-rotator')) {
    customElements.define('zf-announcement-rotator', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.zf-announcement-slide'));
        this.index = 0;
        this.interval = Math.max(2500, Number(this.dataset.interval) || 4000);
        if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.start();
      }
      disconnectedCallback() {
        this.stop();
      }
      start() {
        this.stop();
        this.timer = window.setInterval(() => this.showNext(), this.interval);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }
      showNext() {
        const current = this.slides[this.index];
        this.index = (this.index + 1) % this.slides.length;
        const next = this.slides[this.index];
        current.classList.remove('is-active');
        current.classList.add('is-exiting');
        current.setAttribute('aria-hidden', 'true');
        next.classList.remove('is-exiting');
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
        window.setTimeout(() => current.classList.remove('is-exiting'), 460);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeltron-collection-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-zn-filters]');
    if (!form) return;
    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]')) {
        const matchingInputs = Array.from(form.elements).filter((input) => input !== event.target && input.name === event.target.name && input.value === event.target.value);
        matchingInputs.forEach((input) => { input.checked = event.target.checked; });
      }
      form.requestSubmit();
    });
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const detailsElements = Array.from(form.querySelectorAll('details'));
    const syncMobileLock = () => {
      document.documentElement.classList.toggle('zn-mobile-filter-open', mobileQuery.matches && detailsElements.some((details) => details.open));
    };
    detailsElements.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (mobileQuery.matches && details.open) {
          detailsElements.forEach((other) => { if (other !== details) other.removeAttribute('open'); });
        }
        syncMobileLock();
      });
    });
    form.querySelectorAll('[data-zn-close]').forEach((button) => {
      button.addEventListener('click', () => {
        button.closest('details')?.removeAttribute('open');
        syncMobileLock();
      });
    });
    document.addEventListener('click', (event) => {
      form.querySelectorAll('details[open]').forEach((details) => {
        if (!mobileQuery.matches && !details.contains(event.target)) details.removeAttribute('open');
      });
      syncMobileLock();
    });
  })();

  (() => {
    document.querySelectorAll('.zn-collection__banners').forEach((rail) => {
      const next = rail.querySelector('[data-zn-banner-next]');
      if (!next || next.dataset.ready === 'true') return;
      next.dataset.ready = 'true';
      next.addEventListener('click', () => {
        rail.scrollBy({ left: Math.max(180, rail.clientWidth * .72), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeltron-nomad-home"] && !Shopify.designMode) return;
  try {
    
  document.body.classList.add('zf-figtree-page');
  
  const initSection = () => {
    document.querySelectorAll('[data-zf-section]').forEach((section) => {
      // Keep each marquee half wider than the visible viewport, including browser zoom.
      const marquee = section.querySelector('.zf-payment-marquee');
      if (marquee && !marquee.dataset.zfMarqueeReady) {
        marquee.dataset.zfMarqueeReady = 'true';
        const groups = marquee.querySelectorAll('.zf-payment-marquee__group');
        if (groups.length === 2) {
          const originals = Array.from(groups[0].children).map(item => item.cloneNode(true));
          const fillMarquee = () => {
            const first = groups[0];
            first.replaceChildren(...originals.map(item => item.cloneNode(true)));
            const target = marquee.clientWidth + (first.firstElementChild?.getBoundingClientRect().width || 0);
            let repeats = 0;
            while (first.getBoundingClientRect().width < target && repeats++ < 100) {
              first.append(...originals.map(item => item.cloneNode(true)));
            }
            groups[1].replaceChildren(...Array.from(first.children, item => item.cloneNode(true)));
          };
          fillMarquee();
          window.addEventListener('resize', fillMarquee, { passive: true });
        }
      }
      
      // Hero Slider Logic
      const heroSlider = section.querySelector('[data-zf-hero-slider]');
      if (heroSlider) {
        const slides = heroSlider.querySelectorAll('[data-zf-hero-slide]');
        const dots = heroSlider.querySelectorAll('[data-zf-hero-dot]');
        
        if (slides.length > 1) {
          let currentIndex = 0;
          let slideInterval;

          const goToSlide = (index) => {
            slides[currentIndex].classList.remove('is-active');
            if(dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
            
            currentIndex = index;
            
            slides[currentIndex].classList.add('is-active');
            if(dots[currentIndex]) dots[currentIndex].classList.add('is-active');
          };

          const nextSlide = () => {
            let nextIndex = (currentIndex + 1) % slides.length;
            goToSlide(nextIndex);
          };

          const startAutoPlay = () => {
            clearInterval(slideInterval);
            slideInterval = setInterval(nextSlide, 7000);
          };

          dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              goToSlide(index);
              startAutoPlay(); // Reset timer if clicked manually
            });
          });

          startAutoPlay();
        }
      }

      // Existing rail scripts
      const loveRail = section.querySelector('[data-zf-rail="love"]');
      const featuredRail = section.querySelector('[data-zf-rail="featured"]');
      const scrollRail = (rail, direction) => {
        if (!rail) return;
        rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: 'smooth' });
      };
      
      section.querySelector('[data-zf-prev]')?.addEventListener('click', () => scrollRail(loveRail, -1));
      section.querySelector('[data-zf-next]')?.addEventListener('click', () => scrollRail(loveRail, 1));
      section.querySelector('[data-zf-featured-prev]')?.addEventListener('click', () => scrollRail(featuredRail, -1));
      section.querySelector('[data-zf-featured-next]')?.addEventListener('click', () => scrollRail(featuredRail, 1));
      
      const tabs = Array.from(section.querySelectorAll('[data-zf-tab]'));
      const featuredCards = Array.from(section.querySelectorAll('[data-zf-group]'));
      tabs.forEach((tab) => {
        const hasProducts = featuredCards.some((card) => card.dataset.zfGroup === tab.dataset.zfTab);
        tab.hidden = !hasProducts;
      });
      const availableTabs = tabs.filter((tab) => !tab.hidden);
      const positionMobileArrows = () => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          section.querySelector('.zf-rail-wrap')?.style.removeProperty('--zf-mobile-arrow-top');
          section.querySelector('.zf-heading-row')?.style.removeProperty('--zf-featured-arrow-top');
          return;
        }

        const loveWrap = section.querySelector('.zf-rail-wrap');
        const loveMedia = loveWrap?.querySelector('.zf-product:not([hidden]) .zf-product__media');
        if (loveWrap && loveMedia) {
          const wrapBox = loveWrap.getBoundingClientRect();
          const mediaBox = loveMedia.getBoundingClientRect();
          loveWrap.style.setProperty('--zf-mobile-arrow-top', `${mediaBox.top - wrapBox.top + mediaBox.height / 2}px`);
        }

        const featuredMedia = featuredRail?.querySelector('.zf-product:not([hidden]) .zf-product__media');
        if (featuredMedia) {
          const headingRow = section.querySelector('.zf-heading-row');
          const headingBox = headingRow.getBoundingClientRect();
          const mediaBox = featuredMedia.getBoundingClientRect();
          headingRow.style.setProperty('--zf-featured-arrow-top', `${mediaBox.top - headingBox.top + mediaBox.height / 2}px`);
        }
      };
      
      const activateTab = (group) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.zfTab === group;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        const matches = featuredCards.filter((card) => card.dataset.zfGroup === group);
        featuredCards.forEach((card) => { card.hidden = card.dataset.zfGroup !== group; });
        if (featuredRail) featuredRail.scrollLeft = 0;
        window.requestAnimationFrame(positionMobileArrows);
      };
      
      availableTabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab.dataset.zfTab)));
      if (availableTabs[0]) activateTab(availableTabs[0].dataset.zfTab);
      window.addEventListener('resize', positionMobileArrows, { passive: true });
      window.requestAnimationFrame(positionMobileArrows);
    });
  };

  document.addEventListener('DOMContentLoaded', initSection);
  document.addEventListener('shopify:section:load', initSection); // Re-run if edited in Shopify Theme Editor

  } catch(e) { console.error(e); }
})();
})();
